import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index'
import Home from '../views/HomeV2.vue'

Vue.use(Router)

const ApplyProcess = resolve => {
  import('../views/ApplyProcessV2.vue').then(module => {
    resolve(module)
  })
}
const ProcessImage = resolve => {
  import('../views/ProcessImage.vue').then(module => {
    resolve(module)
  })
}
const Rule = resolve => {
  import('../views/Rule.vue').then(module => {
    resolve(module)
  })
}

const Entered = resolve => {
  import('../views/Entered.vue').then(module => {
    resolve(module)
  })
}

export const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '*',
      redirect: '/'
    },
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/process',
      name: 'process',
      component: ProcessImage
    },
    {
      path: '/rule',
      name: 'rule',
      component: Rule,
      meta: {
        needLogin: true
      }
    },
    {
      path: '/entered',
      name: '已入驻',
      component: Entered
    },
    {
      path: '/apply',
      name: 'apply',
      component: ApplyProcess,
      beforeEnter: (to, from, next) => {
        store.dispatch('getMerchantData').then(isEntered => {
          if (isEntered) router.push('/entered')
          else next()
        })
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  next()
})
